export type BonusEligibilityLike = {
  eligible: boolean;
  reason?: string;
  unjustifiedAbsences: number;
  unjustifiedLates: number;
  unjustifiedTotal: number;
  unjustifiedLimit: number;
};

/** Texto do contador unificado (faltas + atrasos) para bônus do mês. */
export function formatBonusUnjustifiedCounter(bonus: BonusEligibilityLike): string {
  const unjustifiedLimit = bonus.unjustifiedLimit ?? 3;
  const unjustifiedTotal =
    bonus.unjustifiedTotal ??
    (bonus.unjustifiedAbsences ?? 0) + (bonus.unjustifiedLates ?? 0);
  const unjustifiedAbsences = bonus.unjustifiedAbsences ?? 0;
  const unjustifiedLates = bonus.unjustifiedLates ?? 0;
  const breakdown: string[] = [];
  if (unjustifiedAbsences > 0) breakdown.push(`${unjustifiedAbsences} falta(s)`);
  if (unjustifiedLates > 0) breakdown.push(`${unjustifiedLates} atraso(s)`);
  const detail = breakdown.length ? ` · ${breakdown.join(' · ')}` : '';
  const remaining = Math.max(0, unjustifiedLimit - unjustifiedTotal);
  if (bonus.eligible) {
    return `${unjustifiedTotal}/${unjustifiedLimit} injustificados${detail}. Restam ${remaining}.`;
  }
  return `${unjustifiedTotal}/${unjustifiedLimit} injustificados${detail}.`;
}
